import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button, Checkbox, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON_STEP_2 } from './IconStep';
import parse from 'html-react-parser';
import ProgressBar from './ProgressBar';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import Sticky from 'react-sticky-el';
import { useState, useEffect } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { SearchOutlined } from '@ant-design/icons';

const Step2 = (props) => {
    const { t, i18n } = useTranslation(['consent', 'transaction']);
    const [form] = useForm();
    const [searchValue, setSearchValue] = useState();
    const [filteredConsents, setFilteredConsents] = useState([]);

    useEffect(() => {
        if (props?.consents) {
            setFilteredConsents(props?.consents);
        }
    }, [props?.consents]);

    const onNextStep = () => {
        props.form.validateFields(['consents']).then(() => {
            props.nextStep();
        });
    };
    const onPreviousStep = () => {
        props.previousStep();
    };

    const searchConsentList = async (value) => {
        if (props?.consents) {
            const filtered = props?.consents.filter((consent) => {
                const consentNameEn = consent.consentNameEn || '';
                const consentNameTh = consent.consentNameTh || '';

                // Case-insensitive search
                const searchValueLower = value?.toLowerCase();
                const consentNameEnLower = consentNameEn.toLowerCase();
                const consentNameThLower = consentNameTh.toLowerCase();

                return (
                    consentNameEnLower.includes(searchValueLower) ||
                    consentNameThLower.includes(searchValueLower)
                );
            });

            setFilteredConsents(filtered);
        }
    };

    useEffect(() => {
        searchConsentList(searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    return (
        <div className="bg-white p-4 rounded-lg">
            <Sticky
                boundaryElement=".block_"
                stickyClassName="bg-white p-4 shadow rounded-lg z-50"
            >
                <div className="flex justify-between items-center w-full">
                    <Button
                        size="large"
                        className="!border-purple !text-purple"
                        onClick={onPreviousStep}
                    >
                        <ArrowLeftOutlined /> {t('Previous Step')}
                    </Button>
                    <Button type="primary" size="large" onClick={onNextStep}>
                        {t('Next Step')} <ArrowRightOutlined />
                    </Button>
                </div>
            </Sticky>
            <Divider />
            <div className="flex space-x-2 items-center">
                {ICON_STEP_2}
                <div>
                    <div className="text-base font-medium text-[#65707A]">
                        {t('Step')} 2 / 5
                    </div>
                    <div className="text-xl font-semibold">{t('Step2')}</div>
                </div>
            </div>
            <ProgressBar percent={40} />
            {/* <div className="h-[60vh] overflow-y-auto pr-2"> */}
            <div className=" w-full col-span-2">
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    className="mt-4"
                    form={form}
                    onValuesChange={(value) => {
                        setSearchValue(value?.keyword);
                    }}
                >
                    <Form.Item name={'keyword'} className={'m-0'}>
                        <Input
                            size="large"
                            placeholder={t('SearchPurpose')}
                            suffix={<SearchOutlined />}
                        />
                    </Form.Item>
                </Form>
            </div>
            {!filteredConsents || filteredConsents?.length <= 0 ? (
                <>
                    <div className="text-center text-sm space-y-2 my-32">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px] whitespace-pre-line">
                            {t('ConsentTermNoDaTa')}
                        </p>
                    </div>
                </>
            ) : (
                <>
                    <Form.Item
                        name="consents"
                        className="mt-8 consents"
                        rules={[
                            {
                                required: true,
                                message: t('Please choose at least 1 item'),
                            },
                        ]}
                    >
                        <Checkbox.Group className="space-y-4">
                            {filteredConsents.map((consent) => (
                                <div
                                    key={consent.consentTxnGroupId}
                                    className="bg-[#F4F6FC] p-4 rounded-lg"
                                >
                                    <div className="text-tiny font-semibold mb-2">
                                        {i18n === 'EN'
                                            ? parse(consent.consentNameEn)
                                            : parse(consent.consentNameTh)}
                                    </div>
                                    <Checkbox value={consent.consentTxnGroupId}>
                                        {i18n === 'EN'
                                            ? parse(consent.purposeEn)
                                            : parse(consent.purposeTh)}
                                    </Checkbox>
                                </div>
                            ))}
                        </Checkbox.Group>
                    </Form.Item>
                </>
            )}

            <Form.Item name="consentForms" hidden />
            {/* </div> */}
        </div>
    );
};

export default Step2;
